import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";

export const getMetricsQueue = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>
>("metrics/getMetricsQueue", async (metricsPayload, { rejectWithValue }) => {
  try {
    const response = await awsClientGateway({
      pathTemplate: "/queueMetrics",
      method: "POST",
      body: { ...metricsPayload },
    });
    return response;
  } catch (error) {
    clientLog({
      component: `metrics`,
      message: `Something went wrong in getMetricsQueue API => ${error}`,
    });
    logMessage(
      `metrics`,
      `Something went wrong in getMetricsQueue API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in getMetricsQueue api endpoint");
  }
});

export const getMyMetricsData = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "metrics/getMyMetricsData",
  async (myMetricsPayload, { getState, rejectWithValue }) => {
    try {
      const connectedInstance = getState().userInstance.connectedInstance;
      const instanceId = connectedInstance?.instanceId ?? "";
      const response = await awsClientGateway({
        pathTemplate: `/agentMetrics/${instanceId}?apiName=myMetrics`,
        method: "POST",
        body: { ...myMetricsPayload },
      });

      return response;
    } catch (error) {
      clientLog({
        component: `metrics`,
        message: `Something went wrong in getMyMetrics API => ${error}`,
      });
      logMessage(
        `metrics`,
        `Something went wrong in getMyMetrics API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in getMyMetrics api endpoint");
    }
  },
);
